module.exports = __webpack_public_path__ + "static/bg.5beffc99.png";